















import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  name: 'badge-onlinedesign-component',
})
export default class OnlineDesignComponent extends Vue {
  @Prop()
  private onlineDesignUrl: string | undefined;
}
